import React from "react";
import { useTranslation } from "react-i18next";
import { Link, Pill, Text } from "@foris/avocado-suite";
import { Icon } from "@foris/avocado-icons";
import styles from "./programmingResourceEditBtn.module.scss";

interface ProgrammingResourceEditBtnProps {
  items: string[];
  onAssign: () => void;
  isReadOnly?: boolean;
  className?: string;
}

const ProgrammingResourceEditBtn = ({
  items,
  onAssign,
  isReadOnly = false,
  className,
}: ProgrammingResourceEditBtnProps) => {
  const { t } = useTranslation();

  if (items.length === 0) {
    if (isReadOnly) {
      return (
        <Text className={styles.programmingResourceEditBtn_emptyText} type="sm">
          {t("programming-edit.resource-edit.without-assignation")}
        </Text>
      );
    }

    return (
      <Link iconLeft="plus" onClick={onAssign}>
        {t("programming-edit.resource-edit.assign")}
      </Link>
    );
  }

  const [first, ...rest] = items;

  return (
    <div className={`${styles.programmingResourceEditBtn} ${className ?? ""}`}>
      <button className={styles.programmingResourceEditBtn_label} onClick={onAssign}>
        <Icon
          className={styles.programmingResourceEditBtn_editIcon}
          name={isReadOnly ? "open-eye" : "edit"}
          size="sm"
          color="neutral-70"
        />
        <Text className={styles.programmingResourceEditBtn_labelText}>{first}</Text>
      </button>
      {rest.length > 0 && (
        <Pill className={styles.programmingResourceEditBtn_pill}>{`+${rest.length}`}</Pill>
      )}
    </div>
  );
};

export default ProgrammingResourceEditBtn;
